/**
 * Country popup translations helper
 */

import { __ } from '@bart.sk-eshop/react-i18n';

interface PopupTranslations {
  title: string;
  text: string;
  stayButton: string;
  switchButton: string;
}

export const getCountryPopupTranslations = (
  lang: string,
  detectedCountry: string | null,
  hostname: string = '',
): PopupTranslations => {
  const isSlovakSite = hostname.includes('golfcentrum.sk');
  const isCzechSite = hostname.includes('supergolf.cz');
  const isInternationalSite = hostname.includes('golfcentrum.online');

  // User from Czech Republic - show in Czech
  if (detectedCountry === 'CZ') {
    return {
      title: 'Upozornění',
      text:
        'Pokud chcete uskutečnit objednávku do České republiky, klikněte prosím na český web.',
      stayButton: 'Zůstat na tomto webu',
      switchButton: 'Přejít na český web',
    };
  }

  // User from Slovakia - show in Slovak
  if (detectedCountry === 'SK') {
    return {
      title: 'Upozornenie',
      text:
        'Pokiaľ chcete uskutočniť objednávku na Slovensko, kliknite prosím na slovenský web.',
      stayButton: 'Zostať na tomto webe',
      switchButton: 'Prejsť na slovenský web',
    };
  }

  // User from other countries - show in English
  if (isSlovakSite || isCzechSite) {
    return {
      title: 'Notice',
      text: __(
        'For European orders outside Slovakia and Czech Republic, please use our European website.',
      ),
      stayButton: 'Stay on this website',
      switchButton: 'Go to European website',
    };
  }

  // Default - other countries
  return {
    title: 'Notice',
    text: 'You are browsing from outside Slovakia and Czech Republic.',
    stayButton: 'Continue',
    switchButton: 'Go to European website',
  };
};
